import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";
import { initLenis, scrollToTarget, scrollToTop } from "@/lib/lenis";

const ScrollManager = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      setTimeout(() => scrollToTarget(location.hash), 120);
    } else {
      scrollToTop(true);
    }
  }, [location.pathname, location.hash]);
  return null;
};

function App() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <HelmetProvider>
      <div className="App" data-testid="app">
        <BrowserRouter>
          <ScrollManager />
          <Nav />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="*" element={<Home />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
